<!-- 组件模板内容 -->
<template>
  <div>
    <!-- {{ goodsInfo }} -->
    <div style="display: flex">
      <div class="imgBox">
        <el-carousel>
          <el-carousel-item
            v-for="(item, index) in goodsInfo.travelFile"
            :key="index"
          >
            <img :src="item.url" width="100%" height="100%" alt="" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="titleBox">
        <div class="sku-name">
          <!--          <span>自有商品</span>-->
          {{ goodsInfo.title }}
        </div>
        <div class="sku-price">
          <div>
            <span>市场价</span>
            <span>{{ goodsInfo.price | format }}</span>
          </div>
          <div>
            <span>定金</span>
            <span>{{ goodsInfo.deposit | format }}</span>
          </div>
        </div>
        <div class="sku-info">
          <div>
            <span>副标题：</span>
            <span>{{ goodsInfo.subTitle }}</span>
          </div>
          <div>
            <span>排序：</span>
            <span>
             <span>{{ goodsInfo.sortNum }}</span>
            </span>
          </div>

        </div>
      </div>
    </div>
    <div>
      <p v-html="goodsInfo.highlights" id="highlightsId" style="max-width: 100%;"></p>
    </div>

    <div>
      <p v-html="goodsInfo.trip" id="tripId" style="max-width: 100%;"></p>
    </div>

    <div>
      <p v-html="goodsInfo.service" id="serviceId" style="max-width: 100%;"></p>
    </div>

    <div>
      <p v-html="goodsInfo.rule" id="ruleId" style="max-width: 100%;"></p>
    </div>

  </div>
</template>

<script>
import {getTravelDetailById} from "@/api/travleManageApi";
import {formatMoney} from "@/utils/formatMoney";

export default {
  name: "SjGoods",
  // 组件的props定义,用于子组件接收父组件传值
  props: {},
  // 组件的data属性
  data() {
    return {
      goodsInfo: {
        id: 0,
        title: "",
        spuId: null,
        spuTitle: null,
        no: null,
        price: "",
        disPriceType: null,
        disPrice: "",
        detail:"",
        picUrl:"",
        isShow: "",
        crTime: "",
        staffId: "",
        stock: "",
        weight: "",
        freightId: "",
        isDelivery: "",
        deliveryId: "",
        isInstall: "",
        installId: "",
        startNum: 0,
        supplPrice: "",
        chooseId: "",
        type: "",
        sjGoodsId: null,
        costPrice: "",
        showTime: "",
        categoryId1: 0,
        categoryId1Name: "",
        categoryId2: 0,
        categoryId2Name: "",
        categoryId3: null,
        categoryId3Name: null,
        saleNum: 0,
        taobaoUrl: "",
        jdUrl: "",
        salePrice: "",
        isQuan: "",
        ratio: "",
        isJD: "",
        code: "",
        sevenNRR: 0,
        recommend: 1,
        deliveryTime: null,
        level: "",
        status: "",
        specialSpec: null,
        isTwoShow: 0,
        profit: 0,
        poolDisPrice: "",
        commentCount: 0,
        pcPrice: null,
        pcMark: 0,
        pcTime: "",
        skuId: null,
        skuName: null,
        userId: null,
        quanSupplyPrice: null,
        chuantype: null,
        rightRate: null,
        sjGoodsStaffId: null,
        categoryName: null,
        maxRightRate: null,
        buyType: null,
        resType: null,
        isShowTime: null,
        image: null,
        goodsFrom: null,
        staffFlag: null,
        saleAttrVo: [
          {
            attrId: null,
            attrName: null,
            attrValues: [{ attrValue: null, skuIds: "6937" }],
          },
        ],
        saleAttr: null,
        travelFile: [
          {
            id: 0,
            name: "",
            url: "",
            crTime: "",
            sid: "",
          },
        ],
        pstaffId: "",
        deposit:"",
        subTitle: "",
        sortNum:"",
        highlights:"",
        trip:"",
        service:"",
        rule:"",
      },
    };
  },
  filters: {
    format(num) {
      return formatMoney(num);
    },
  },
  // 组件的方法
  methods: {
    async getTravelInfo(id) {
      this.goodsInfo = {
        title: "",
        travelFile: [{ url: "" }],
        detail: "",
      };
      let { data } = await getTravelDetailById({
        id
      });
      this.goodsInfo = data;
    },
  },
  // 在created钩子中执行的操作
  created() {},
};
</script>
<style>
#detailId>p>img{
  width: 100%;
}
#highlightsId>p>img{
  width: 100%;
}
#tripId>p>img{
  width: 100%;
}
#serviceId>p>img{
  width: 100%;
}
#ruleId>p>img{
  width: 100%;
}
</style>
<!-- 组件的样式 -->
<style scoped>

.imgBox {
  width: 400px;
  padding: 10px;
}
.titleBox {
  padding: 10px;
}
.sku-name {
  font: 700 16px Arial, "microsoft yahei";
  color: #666;
  padding-top: 10px;
  line-height: 28px;
  margin-bottom: 5px;
}
.sku-name span {
  display: inline-block;
  /* height: 14px; */
  padding: 5px;
  line-height: 14px;
  font-family: arial, simsun;
  color: #fff;
  background: #e4393c;
  margin-left: 6px;
  font-size: 14px;
  cursor: pointer;
}
.sku-price {
  font-size: 16px;
  font-weight: bold;
  background: #f3f3f3;
  padding: 10px;
}
.sku-price >div span:nth-child(1){
    font-size: 12px;
    font-weight: 100;
}
.sku-price >div span:nth-child(2){
    color: red;
    font-size: 18px;
    margin-left: 10px;
    font-weight:500;

}
.sku-info{
    margin-top: 10px;
}
.sku-info >div{
    margin-top: 5px;
}
.sku-info >div span:nth-child(1){

}
.sku-info >div span:nth-child(2){
    margin-left: 10px;
}
</style>
